import { TCompanies } from './const'

/*
 * Wie ein Bericht heisst, haengt von der Unternehmensform ab — nicht nur von der
 * gespeicherten Berichtsart.
 *
 * Junior Basic Company und Junior Compact Company reichen genau EINEN Abschluss ein.
 * Beide Formulare schicken ihn als `SEMIANNUAL` ab, weshalb die Listen der
 * Administration ihn als "Halbjahresbericht" fuehrten, obwohl es der Jahresabschluss
 * ist und die Schueler:innen-Ansicht ihn richtig benennt (Anforderung #87).
 *
 * Die gespeicherte Berichtsart bleibt unveraendert — das hier ist nur die Beschriftung.
 */
export const reportTypeLabel = (reportType, companyType, t) => {
	if (companyType === TCompanies.JBC || companyType === TCompanies.JCC) return t('Jahresabschluss')

	return reportType ? t(reportType) : ''
}
